// extracted by mini-css-extract-plugin
export default {"page":"VX-z","cartModal":"WX-z","checkout":"XX-z","placeholder":"YX-z","account":"ZX-z"};